import {
  getUpdatedScreenApiCalledList,
  getUpdatedScreenDataPool,
  getUpdatedScreenWidgetList,
  getUpdatedScreenWidgetListBasedOnCompetitorCheck,
  getUpdatedScreenWidgetListWithChartSettings,
  getUpdatedScreenWidgetListWithProp,
  getUpdatedScreenWidgetListWithPropAndClearGraphData,
  getUpdatedScreenWidgetListWithXAxis,
  getUpdatedScreenWidgetMetaDataList,
} from "../../../constants/commandCenterConstants";
import { initialScreen } from "../../../constants/enums";

let initialState = {
  loader: false,
  date_aggregaion_loader: false,
  animated_widget_loader: false,
  refreshEvent: false,
  globalChangeInprogress: false,
  // for uniqueStateCityData
  countryStateCityLoader: false,
  countryStateCityData: null,
  // for searched topic
  selectedSearchedTopic: null,
  searchedTopicLoader: false,
  searchedTopicList: null,

  screen: initialScreen,
  screen_called_api_list: [],
  globe_pin_toggle: true,
  screen_setting_flag: false,
  screen_personalization_flag: false,
  selected_mention_globe_data: {
    latitude: "",
    longitude: "",
    sentimentType: "",
  },
  show_location_data: false,
  open_campaign_popup: false,
  campaign_profile_list: null,
  campaign_quick_profile: null,
  onHoverStopTimeout: false,
  isGlobePlayAndPauseAnimation: false,
  signalRMentionDataForThreeDGlobeScreen: [],
  screen_header_filter_pills: [],
  screenDataPool: null,
  screenDataPoolingInprogress: false,
  pauseAnimationWhenPopupOpen: false,
  personalization_settings: {
    themeName: "Pastel Theme",
    themeId: "000-000-003",
    themeDescription: "",
    isPredefined: null,
    PreviewScreenId: null,
    savedAs: null,
    loader: false,
    selectedConfigureComponent: null,
    brandUploadLoader: false,
    brandConfig: {
      logoUrl: null,
      position: null,
    },
    CommandCenterLayout: null,
    sameConfigForBannerAndFooter: false,
    CommandCenterScreenBanner: {
      background: null,
      title: null,
      subtitle: null,
      textPosition: null,
      textColor: null,
      fontFamily: null,
      fontSize: null,
    },
    CommandCenterScreenFooter: {
      subtitle: null,
      textPosition: null,
      textColor: null,
    },
    themeList: null,
    paletteList: [
      {
        name: "Soft and serene",
        isSelected: false,
        PrimaryTextColor: "#4A4A4A",
        SecondaryTextColor: "#7D7D7D",
        ScreenBackgroundColor: "#F1F8E9",
        WidgetHeaderColor: "#A5D6A7",
        WidgetBackgroundColor: "#81D4FA",
        AccentColors: ["#FFB74D", "#FF80AB", "#C5E1A5", "#F48FB1"],
      },
      {
        name: "Warm and Cozy",
        isSelected: false,
        PrimaryTextColor: "#3E3E3E",
        SecondaryTextColor: "#9E9E9E",
        ScreenBackgroundColor: "#FFF3E0",
        WidgetHeaderColor: "#FFCC80",
        WidgetBackgroundColor: "#FFB74D",
        AccentColors: ["#81D4FA", "#C5E1A5", "#FFEB3B", "#FF8A65"],
      },
      {
        name: "Cool and Refreshing",
        isSelected: false,
        PrimaryTextColor: "#4A4A4A",
        SecondaryTextColor: "#9E9E9E",
        ScreenBackgroundColor: "#E1F5FE",
        WidgetHeaderColor: "#80DEEA",
        WidgetBackgroundColor: "#26C6DA",
        AccentColors: ["#FF4081", "#81C784", "#FFEB3B", "#64B5F6"],
      },
    ],
    logosJson: {
      bannerImage: null,
      brandLogo: null,
    },
  },
  // themeList: null,
};
const Screens = (state = initialState, action) => {
  let updatedScreenWidgetList;
  let propValue;
  switch (action.type) {
    case "RESET_SCREEN":
      return {
        ...initialState,
      };
    case "SET_IS_COMPETITOR":
      return {
        ...state,
        screen: {
          ...state.screen,
          settings: {
            ...state.screen.settings,
            is_competitor: action.value,
          },
        },
      };
    case "SET_DATE_AGGREGATION_LOADER":
      return {
        ...state,
        date_aggregaion_loader: action.value,
      };
    case "SET_ANIMATED_WIDGET_LOADER":
      return {
        ...state,
        animated_widget_loader: action.value,
      };
    case "SET_SCREEN_LOADER":
      return {
        ...state,
        loader: action.value,
      };
    case "SET_SCREEN_REFRESH_EVENT":
      return {
        ...state,
        refreshEvent: action.value,
      };
    case "SET_SCREEN_SETTING_FLAG":
      return {
        ...state,
        screen_setting_flag: action.value,
      };
    case "SET_SCREEN_PERSONALIZATION_FLAG":
      return {
        ...state,
        screen_personalization_flag: action.value,
      };
    case "SET_BRANDS_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          brands: action?.brands,
        },
      };
    case "SET_SELECTED_DURATION_TYPE_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          selected_duration_type: action?.selected_duration_type,
        },
      };
    case "SET_SELECTED_DURATION_TYPE_FLAG_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          selected_duration_type_flag: action?.selected_duration_type_flag,
        },
      };
    case "SET_DURATION_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          duration: action?.duration,
        },
      };
    case "SET_FILTERS_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          filters: action?.filters,
        },
      };
    case "SET_CATEGORY_SCREEN_FILTERS":
      return {
        ...state,
        screen: {
          ...state?.screen,
          category_screen_filters: action?.category_screen_filters,
        },
      };
    case "SET_IS_DEEP_DIVE_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          isDeepDive: action?.isDeepDive,
          deep_dive: action?.deep_dive,
        },
      };
    case "SET_IS_DEEP_DIVE_DASHBOARD_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          isDeepDiveDashboard: action?.isDeepDiveDashboard,
        },
      };
    case "SET_DEEP_DIVE_DATA_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          isDeepDive: action?.isDeepDive,
          deep_dive: {
            ...state?.screen?.deep_dive,
            ...action?.deep_dive,
          },
        },
      };
    case "SET_DEEP_DIVE_DATA_IN_SCREEN_FOR_TWITTER_TREND":
      return {
        ...state,
        screen: {
          ...state?.screen,
          isDeepDive: action?.isDeepDive,
          deep_dive: {
            ...state?.screen?.deep_dive,
            twitter_trend: {
              ...state?.screen?.deep_dive?.twitter_trend,
              ...action?.deep_dive?.twitter_trend,
            },
          },
        },
      };
    case "SET_SELECTED_DEEPDIVE_WIDGET_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          selected_deepdive_widget: action?.selected_deepdive_widget,
        },
      };
    case "SET_SCREEN_UPDATED_DATA":
      const selectedTheme = { ...action?.updatedScreenData.theme };
      return {
        ...state,
        screen: {
          ...state?.screen,
          ...action?.updatedScreenData,
        },
        personalization_settings: {
          ...state.personalization_settings,
          themeName: selectedTheme?.theme_name,
          themeId: selectedTheme?.theme_id,
          PreviewScreenId: action?.updatedScreenData?.screen_id,
          themeDescription: selectedTheme?.theme_description,
          isPredefined: selectedTheme?.is_predefined,
          savedAs: selectedTheme?.saved_as,
          selectedConfigureComponent: null,
          brandUploadLoader: false,
          brandConfig: {
            ...state.personalization_settings.brandConfig,
            ...selectedTheme?.theme_json.brandConfig,
          },
          CommandCenterLayout: selectedTheme?.theme_json.CommandCenterLayout,
          CommandCenterScreenBanner: {
            ...state.personalization_settings.CommandCenterScreenBanner,
            ...selectedTheme?.theme_json.CommandCenterScreenBanner,
          },
          CommandCenterScreenFooter: {
            ...state.personalization_settings.CommandCenterScreenFooter,
            ...selectedTheme?.theme_json.CommandCenterScreenFooter,
          },
          paletteList:
            selectedTheme?.theme_json.paletteList || state.paletteList,
          logosJson: {
            ...state.personalization_settings.logosJson,
            ...selectedTheme?.logos_json,
          },
        },
      };
    case "UPDATE_SCREEN_API_CALLED_LIST":
      // first we take update list based on action ADD/REMOVE, then update list
      let updatedScreenCalledApiList = getUpdatedScreenApiCalledList(
        [...state?.screen_called_api_list],
        action?.widgetId,
        action?.operation
      );
      return {
        ...state,
        screen_called_api_list: [...updatedScreenCalledApiList],
      };
    case "CLEAR_SCREEN_WIDGET_GRAPH_DATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList = getUpdatedScreenWidgetList(
        { ...state?.screen },
        action?.sectionIndex,
        action?.widgetIndex,
        action?.operation,
        null,
        null,
        null,
        action?.widget_id,
        action?.isRefreshEvent,
        action?.widgetRefreshId,
        action?.presistDataStored
      );
      if (action?.presistDataStored) {
        updatedScreenWidgetList[action?.widgetIndex].reserved_data = null;
        updatedScreenWidgetList[
          action?.widgetIndex
        ].stored_in_reserved_data = true;
      }

      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "CLEAR_ALL_SCREEN_WIDGET_GRAPH_DATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList = getUpdatedScreenWidgetList(
        { ...state?.screen },
        null,
        null,
        action?.operation,
        null,
        null,
        null,
        null,
        action?.isRefreshEvent,
        action?.widgetRefreshId
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
        globalChangeInprogress: action?.globalChangeInprogress,
      };
    case "UPDATE_SCREEN_WIDGET_GRAPH_DATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList = getUpdatedScreenWidgetList(
        { ...state?.screen },
        action?.sectionIndex,
        action?.widgetIndex,
        action?.operation,
        action?.graphData,
        action?.body,
        action?.graphObject
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "UPDATE_SCREEN_WIDGET_META_DATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList = getUpdatedScreenWidgetMetaDataList(
        { ...state?.screen },
        action?.sectionIndex,
        action?.widgetIndex,
        action?.operation,
        action?.metadata,
        action?.sectionId
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "UPDATE_SCREEN_WIDGET_META_DATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList = getUpdatedScreenWidgetMetaDataList(
        { ...state?.screen },
        action?.sectionIndex,
        action?.widgetIndex,
        action?.operation,
        action?.metadata,
        action?.sectionId
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "UPDATE_SCREEN_WIDGET_PROP_DATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList = getUpdatedScreenWidgetListWithProp(
        { ...state?.screen },
        action?.sectionIndex,
        action?.widgetIndex,
        action?.updatedProp
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "UPDATE_SCREEN_WIDGET_WITH_PROP_DATA_AND_CLEAR_GRAPHDATA":
      // first we take update widget list based on action CLEAR/UPDATE, then update widget list
      updatedScreenWidgetList =
        getUpdatedScreenWidgetListWithPropAndClearGraphData(
          { ...state?.screen },
          action?.sectionIndex,
          action?.widgetIndex,
          action?.updatedProp,
          action?.isNeedToUpdateAllWidgetWithSameId,
          action?.presistDataStored
        );
      if (action?.presistDataStored) {
        updatedScreenWidgetList[action?.widgetIndex].reserved_data = null;
        updatedScreenWidgetList[
          action?.widgetIndex
        ].stored_in_reserved_data = true;
      }
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };

    case "ON_GLOBE_PIN_TOGGLE_CHANGE":
      return {
        ...state,
        globe_pin_toggle: action?.globePinToggleValue,
      };
    case "SET_TAGCLOUD_FILTER_FILL_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          tagcloud_filter_pill: action?.tagcloud_filter_pill,
        },
      };
    case "SET_TAGCLOUD_FILTER_FILL_IN_ALL_SCREEN_WIDGET":
      // first we take update widget list based on action ALL_CLEAR, then update widget list
      propValue = {
        attribute: action?.propValue?.value,
        trace_name: action?.propValue?.label,
      };
      updatedScreenWidgetList = getUpdatedScreenWidgetListWithXAxis(
        { ...state?.screen },
        null,
        null,
        action?.operation,
        action?.propName,
        propValue
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "SET_DATE_AGGREGATION":
      // first we take update widget list based on action ALL_CLEAR, then update widget list
      propValue = {
        date_aggregation: action?.propValue,
      };

      updatedScreenWidgetList = getUpdatedScreenWidgetListWithXAxis(
        { ...state?.screen },
        action?.sectionIndex,
        action?.widgetIndex,
        action?.operation,
        action?.propName,
        propValue
      );
      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "UPDATE_SETTINGS_IN_SCREEN":
      if (action?.propName === "color_style") {
        updatedScreenWidgetList = getUpdatedScreenWidgetListWithChartSettings(
          { ...state?.screen },
          null,
          null,
          action?.operation,
          "wordcloud_color",
          action?.propValue
        );
      } else if (action?.propName === "number_of_words") {
        propValue = {
          x_limit: action?.propValue,
        };
        updatedScreenWidgetList = getUpdatedScreenWidgetListWithXAxis(
          { ...state?.screen },
          null,
          null,
          action?.operation,
          "x_axis",
          propValue
        );
      } else if (action?.propName === "number_of_nodes") {
        propValue = {
          y_limit: action?.propValue,
        };
        updatedScreenWidgetList = getUpdatedScreenWidgetListWithXAxis(
          { ...state?.screen },
          null,
          null,
          action?.operation,
          "y_axes",
          propValue
        );
      } else if (action?.propName === "is_competitor") {
        updatedScreenWidgetList =
          getUpdatedScreenWidgetListBasedOnCompetitorCheck(
            { ...state?.screen },
            null,
            action?.propValue,
            action?.userBrands,
            action?.objForTemporyWordFunctionality
          );
      } else if (action?.propName === "radius_attribute") {
        propValue = {
          radius_attribute: action?.propValue,
        };
        updatedScreenWidgetList = getUpdatedScreenWidgetListWithXAxis(
          { ...state?.screen },
          null,
          null,
          action?.operation,
          "x_axis",
          propValue,
          action?.graphConditions
        );
      }
      return {
        ...state,
        screen: {
          ...state?.screen,
          settings: {
            ...state?.screen?.settings,
            [action?.propName]: action?.propValue,
          },
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "ON_CLICK_MENTION_GLOBE_ICON":
      return {
        ...state,
        selected_mention_globe_data: action.data,
      };
    case "ON_CLICK_LOCATION_ICON":
      return {
        ...state,
        show_location_data: action.data,
      };
    case "SET_WIDGET_X_AXIS_ATTRIBUTE":
      let updatedScreen = { ...state?.screen };
      updatedScreenWidgetList = updatedScreen.widgets?.map((wid) => {
        if (action?.widget_list?.includes(wid?.widget_id)) {
          wid.x_axis[action?.propName] = action?.propValue;
        }
        return wid;
      });
      // console.log("updatedScreenWidgetList", updatedScreenWidgetList);

      return {
        ...state,
        screen: {
          ...state?.screen,
          widgets:
            updatedScreenWidgetList?.length > 0
              ? updatedScreenWidgetList
              : state?.screen?.widgets,
        },
      };
    case "SET_STREAM_SCREEN_BRAND":
      return {
        ...state,
        screen: {
          ...state?.screen,
          stream_screen_brand: action?.stream_screen_brand,
        },
      };
    case "SET_CURRENT_SCREEN_BRAND":
      return {
        ...state,
        screen: {
          ...state?.screen,
          current_screen_brand: action?.current_screen_brand,
        },
      };
    case "SET_STREAM_SCREEN_FILTERS":
      return {
        ...state,
        screen: {
          ...state?.screen,
          stream_screen_filters: action?.stream_screen_filters,
        },
      };
    case "SET_STREAM_SCREEN_DEFAULT_WIDGET":
      return {
        ...state,
        screen: {
          ...state?.screen,
          stream_screen_default_widget: action?.stream_screen_default_widget,
        },
      };
    case "SET_OPEN_CAMPAIGN_POPUP":
      return {
        ...state,
        open_campaign_popup: action?.value,
      };
    case "SET_CAMPAIGN_PROFILE_LIST":
      return {
        ...state,
        campaign_profile_list: action?.value,
      };
    case "SET_CAMPAIGN_QUICK_PROFILE":
      return {
        ...state,
        campaign_quick_profile: action?.value,
      };
    case "SET_PROFILE_LIST_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          profiles: action?.profiles,
        },
      };
    case "SET_SELECTED_QUICK_PROFILE_IN_SCREEN":
      return {
        ...state,
        screen: {
          ...state?.screen,
          selected_quick_profile: action?.selectedProfile,
        },
      };
    case "SET_SCREEN_CAMPAIGN_DATE":
      return {
        ...state,
        screen: {
          ...state?.screen,
          campaign_date: action?.duration,
        },
      };
    case "SET_GLOBE_CHANGE_INPROGRESS":
      return {
        ...state,
        globalChangeInprogress: action?.value,
      };
    case "SET_ON_HOVER_STOP_TIMEOUT":
      return {
        ...state,
        onHoverStopTimeout: action?.value,
      };
    case "SET_GLOBE_PLAY_AND_PAUSE_ANIMATION":
      return {
        ...state,
        onHoverStopTimeout: action?.value,
        isGlobePlayAndPauseAnimation: action?.value,
      };
    case "SET_SIGNALR_MENTION_DATA_FOR_THREE_D_GLOBE_SCREEN":
      const updatedData = Array.isArray(action?.data)
        ? action?.data
        : [...state?.signalRMentionDataForThreeDGlobeScreen, action?.data];
      return {
        ...state,
        signalRMentionDataForThreeDGlobeScreen: updatedData,
      };
    case "SET_MARK_INFLUENCERS_LIST":
      return {
        ...state,
        screen: {
          ...state?.screen,
          markInfluencersList: action?.markInfluencersList,
        },
      };
    case "SET_MARK_INFLUENCERS_FLAG":
      return {
        ...state,
        screen: {
          ...state?.screen,
          markInfluencersFlag: action?.markInfluencersFlag,
        },
      };
    case "SET_DELETE_POST_FLAG":
      return {
        ...state,
        screen: {
          ...state?.screen,
          deletePostFlag: action?.deletePostFlag,
        },
      };
    case "SET_SCREEN_HEADER_FILTER_PILLS":
      return {
        ...state,
        screen_header_filter_pills: action.value,
      };
    case "SET_SCREEN_DATA_POOL":
      return {
        ...state,
        screenDataPool: action.value,
        screenDataPoolingInprogress: false,
      };
    case "UPDATE_SCREEN_DATA_POOL":
      let updatedScreenDataPool = getUpdatedScreenDataPool(
        { ...state?.screenDataPool },
        action?.operation,
        action?.widget_id,
        action?.newData
      );
      return {
        ...state,
        screenDataPool:
          updatedScreenDataPool?.[action?.widget_id] &&
          updatedScreenDataPool?.[action?.widget_id]?.[0]?.data?.length > 0
            ? updatedScreenDataPool
            : state?.screenDataPool,
        screenDataPoolingInprogress: false,
      };
    case "SET_SCREEN_DATA_POOLING_INPROGRESS":
      return {
        ...state,
        screenDataPoolingInprogress: action.value,
      };
    case "SET_PAUSE_ANIMATION_WHEN_POPUP_OPEN":
      return {
        ...state,
        pauseAnimationWhenPopupOpen: action.value,
      };
    case "SET_COUNTRY_STATE_CITY_LOADER":
      return {
        ...state,
        countryStateCityLoader: action?.loader,
      };
    case "SET_COUNTRY_STATE_CITY_DATA":
      return {
        ...state,
        countryStateCityData: action?.countryStateCityList,
      };
    case "SET_SELECTED_SEARCHED_TOPIC":
      return {
        ...state,
        selectedSearchedTopic: action?.selectedSearchedTopic,
      };
    case "SET_SEARCHED_TOPIC_LOADER":
      return {
        ...state,
        searchedTopicLoader: action?.loader,
      };
    case "SET_SEARCHED_TOPIC_LIST":
      return {
        ...state,
        searchedTopicList: action?.searchedTopicList,
      };
    case "SET_COUNTRY_STATE_CITY_FILTERS":
      return {
        ...state,
        screen: {
          ...state?.screen,
          country_state_city_filters: action?.country_state_city_filters,
        },
      };
    case "SET_PERSONALISATION_SETTINGS":
      return {
        ...state,
        personalization_settings: action.value,
      };
    default:
      return state;
  }
};

export default Screens;
